module.exports = __webpack_public_path__ + "img/points-exchange-header.68225b7a.png";